import React, { useCallback, useEffect, useRef } from "react";
import { Button, Fade } from "@mui/material";
import { useSelector } from "../../../app/helpers";
import { useTranslation } from "react-i18next";
import { RootState } from "../../../app/rootReducer";
import { Save } from "@mui/icons-material";
import FormConfirmCard from "./FormConfirmCard/FormConfirmCard";

interface OwnProps {
  showConfirmAnim: boolean;
  confirmingBooking: boolean;
  nextStep: () => void;
  onChangeTimezone: (newTimezone: string) => unknown;
  /** When true, confirm button is disabled (e.g. vehicle booking without trip reason) */
  confirmDisabled?: boolean;
}

type Props = OwnProps;

const FormConfirmData: React.FC<Props> = props => {
  const { inputs } = useSelector((state: RootState) => state.booking);
  const { t } = useTranslation();
  const submitLockRef = useRef(false);

  useEffect(() => {
    if (!props.confirmingBooking && !props.showConfirmAnim) {
      submitLockRef.current = false;
    }
  }, [props.confirmingBooking, props.showConfirmAnim]);

  const handleConfirmClick = useCallback(() => {
    if (
      submitLockRef.current ||
      props.confirmingBooking ||
      props.showConfirmAnim ||
      props.confirmDisabled
    ) {
      return;
    }

    submitLockRef.current = true;
    props.nextStep();
  }, [props.confirmDisabled, props.confirmingBooking, props.nextStep, props.showConfirmAnim]);

  return (
    <>
      <FormConfirmCard onChangeTimezone={props.onChangeTimezone} />
      <Fade in={!!inputs.bookingFrom}>
        <Button
          sx={{ width: "100%", margin: "5px 5px 5px 0" }}
          data-testid={"confirm-booking-btn"}
          loading={props.confirmingBooking}
          disabled={props.showConfirmAnim || props.confirmDisabled || submitLockRef.current}
          color={"primary"}
          variant={"contained"}
          onClick={handleConfirmClick}
          startIcon={<Save />}
          loadingPosition={"start"}
        >
          {t("Confirm")}
        </Button>
      </Fade>
    </>
  );
};

export default FormConfirmData;
